import React, { useState } from "react";
import axios from "./axios";
import { useNavigate } from "react-router-dom";
import { IoAlertCircleOutline } from "react-icons/io5";

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
    repeatPassword: "",
  });

  const [errors, setErrors] = useState({
    fullname: "",
    email: "",
    password: "",
    repeatPassword: "",
    serverError: "",
  });

  const [successMessage, setSuccessMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (value.trim() === "") {
        newErrors[key] = "Este campo no puede quedar vacío";
        isValid = false;
      }
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = "Ingrese un correo electrónico válido";
      isValid = false;
    }

    const fullNameRegex = /^[a-zA-Z\u00C0-\u017F']+(\s[a-zA-Z\u00C0-\u017F']+)*\s*$/;
    if (!formData.fullname.trim() || !fullNameRegex.test(formData.fullname)) {
      newErrors.fullname = "Ingrese un nombre y apellido válido";
      isValid = false;
    }

    if (formData.password.length < 6) {
      newErrors.password = "La contraseña debe tener al menos 6 caracteres";
      isValid = false;
    } else {
      if (formData.password !== formData.repeatPassword) {
        newErrors.repeatPassword = "Las contraseñas no coinciden";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    } else {
      try {
        const res = await axios.post(`${apiUrl}/users`, JSON.stringify(formData), {
          headers: { "Content-Type": "application/json" },
          method: "POST",
        });
        //envío de mail
        try {
          await axios.post(`${apiUrl}/users/send`, JSON.stringify(formData), {
            headers: { "Content-Type": "application/json" },
            method: "POST",
          });
          console.log(res);
        } catch(error){
          console.log(error);
        }
        if (res.status === 201){
          setSuccessMessage(
            "¡Registro exitoso! Iniciá sesión para comenzar a jugar. En instantes te redirigiremos."
          );
          setTimeout(() => {
            navigate("/");
          }, 2500);
        } else {
          setErrors({ ...errors, serverError: "Hubo un error" });
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setErrors({ ...errors, serverError: error.response.data.error });
        } else {
          setErrors({ ...errors, serverError: "Hubo un error" });
        }
      }
    }
  };

  return (
    <form className="r-form" onSubmit={handleSubmit}>
      <div className="r-row">
        <label>
          <span>Nombre y Apellido:</span>
          <input
            type="text"
            name="fullname"
            value={formData.fullname}
            onChange={handleChange}
          />
          {errors.fullname && (
            <p className="error-message">
              {" "}
              <IoAlertCircleOutline /> {errors.fullname}
            </p>
          )}
        </label>
        <label>
          <span>Email:</span>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && (
            <p className="error-message">
              {" "}
              <IoAlertCircleOutline /> {errors.email}
            </p>
          )}
        </label>
      </div>
      <div className="r-row">
        <label>
          <span>Contraseña</span>
          <input
            className="password-input-container"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
          {errors.password && (
            <p className="error-message">
              {" "}
              <IoAlertCircleOutline /> {errors.password}
            </p>
          )}
        </label>
        <label>
          <span>Confirmar contraseña:</span>
          <input
            className="repeat-password-input-container"
            type="password"
            name="repeatPassword"
            value={formData.repeatPassword}
            onChange={handleChange}
          />
          {errors.repeatPassword && (
            <p className="error-message">
              {" "}
              <IoAlertCircleOutline /> {errors.repeatPassword}
            </p>
          )}
        </label>
      </div>
      {errors.serverError && (
        <p className="error-message">
          {" "}
          <IoAlertCircleOutline /> {errors.serverError}
        </p>
      )}
      {successMessage && <p className="success-message">{successMessage}</p>}
      <button className="button button-info login" type="submit">
        Registrarse
      </button>
    </form>
  );
};

export default Register;